import { DownOutlined } from '@ant-design/icons';
import { Button, DatePicker, Radio } from 'antd';
import { createIsoTimeRange, DEFAULT_TIMEZONE } from 'lib/utils/DateUtils';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import selectIcon from 'static/icons/select-icon.svg';
import close from 'static/images/close.png';

export default DateRangePicker = ({ dateRange, onSetDateRange, onSetShowDatePanel, timezone, setMobileScroll, ...props }) => {
    const { RangePicker } = DatePicker;
    const [open, setOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(screen.width <= 766);
    const [mobileDates, setMobileDates] = useState([new Date(), null]);
    const [dateRangeListSelect, setDateRangeListSelect] = useState({ dates: dateRange?.dates ? dateRange.dates : dateRange });
    const [showDatePanel, setShowDatePanel] = useState({ list: false, range: false });

    const dateRangeList = [
        { title: 'Today', range: createIsoTimeRange('today', timezone, true), value: 'today' },
        { title: 'Yesterday', range: createIsoTimeRange('yesterday', timezone, true), value: 'yesterday' },
        { title: 'Last 3 Days', range: createIsoTimeRange('last3days', timezone, true), value: 'last-3-days' },
        { title: 'Last 7 Days', range: createIsoTimeRange('last7days', timezone, true), value: 'last-7-days' },
        { title: 'Last 30 Days', range: createIsoTimeRange('last30days', timezone, true), value: 'last-30-days' },
        { title: 'This Month', range: createIsoTimeRange('thisMonth', timezone, true), value: 'this-month' },
        { title: 'Last Month', range: createIsoTimeRange('lastMonth', timezone, true), value: 'last-month' },
        { title: 'Custom', value: 'custom' }
    ];

    useEffect(() => {
        if (setMobileScroll) setMobileScroll(showDatePanel?.list || showDatePanel?.range);
    }, [showDatePanel]);

    useEffect(() => {
        if (dateRangeListSelect.dates.length) {
            setMobileDates(dateRangeListSelect.dates.map((date) => new Date(date)));
        }
    }, [dateRangeListSelect.dates])

    useEffect(() => {
        window.addEventListener('resize', () => setIsMobile(screen.width <= 766));
    }, []);

    toggleFilterPanel = () => {
        let v = { list: !showDatePanel?.list, range: false };
        updateDatePanel(v);
    };

    updateDatePanel = (v) => {
        setShowDatePanel(v);
        if (onSetShowDatePanel) onSetShowDatePanel(v);
    }

    changeDateRangeFilter = val => {
        const copyVal = val.filter(date => date);
        setDateRangeListSelect({ selected: '', dates: copyVal.length ? val : dateRangeListSelect.dates });
        setOpen(true);
    };

    const dateRangeTitle = dateRangeListSelect.dates.length ?
        (dateRangeListSelect.selected === 'today' || dateRangeListSelect.selected === 'yesterday')
            ? dateRangeListSelect.dates[0].format('MMM DD, YYYY')
            : `${dateRangeListSelect.dates[0]?.format('MMM DD, YYYY')} to ${dateRangeListSelect.dates[1]?.format('MMM DD')}` : '';

    const onDateRangeClick = ({ value, range }) => {
        if (value === 'custom') {
            setShowDatePanel({ list: false, range: true });
            if (onSetShowDatePanel) onSetShowDatePanel({ list: false, range: true });
            setDateRangeListSelect({ ...dateRangeListSelect, selected: value });
            if (onSetDateRange) onSetDateRange({ ...dateRangeListSelect, selected: value });
            return;
        }
        //setShowDatePanel({ list: false, range: false });
        if (onSetShowDatePanel) onSetShowDatePanel({ list: false, range: false });
        setDateRangeListSelect({ ...dateRangeListSelect, selected: value, dates: range });
        if (onSetDateRange) onSetDateRange({ ...dateRangeListSelect, selected: value, dates: range });
        updateDatePanel({ list: false, range: false })
    }

    const dateRangeListView = dateRangeList.map(({ title, range, value }, idx) => {
        return (
            <div key={idx} onClick={() => onDateRangeClick({ value, range })} className={`filter-option filter-option-range`}>
                <div className="option-title">
                    {title}
                    <p>
                        {range?.length
                            ? range?.[0].isSame(range?.[1])
                                ? range?.[0].format('MMMM DD')
                                : `${range?.[0].format('MMMM DD')} - ${range?.[1].format('MMMM DD')}`
                            : dateRangeListSelect.selected === 'custom'
                                ? dateRangeTitle
                                : ''
                        }
                    </p>
                </div>
                <Radio checked={dateRangeListSelect.selected === value} />
            </div>
        );
    });

    const confirmDateRange = () => {
        setOpen(false);
        onDateConfirm({ selected: dateRangeListSelect.selected, dates: dateRangeListSelect.dates });
        if (onSetDateRange) onSetDateRange(dateRangeListSelect.dates);
        setShowDatePanel({ list: false, range: false });
        if (onSetShowDatePanel) onSetShowDatePanel({ list: false, range: false });

    };

    const DatePickerExtraFooter = (...props) => {
        return (
            <div>
                <div className="range-picker-extra-footer">
                    <b className="list-header">Date Presets</b>
                    {dateRangeList.map(({ title, value, range }, i) => (
                        <div key={i}
                            className={`date-range-div ${dateRangeListSelect.selected === value && 'selectedRange'}`}
                            onClick={() => setDateRangeListSelect({ selected: value, dates: range })}>
                            {dateRangeListSelect.selected === value ? <img className="select-icon" src={selectIcon} alt="select icon" /> : <div className="non-select-icon" />}{' '}
                            {title}
                        </div>
                    ))}
                </div>
                <div className="calendarFooter">
                    <div className="calendarTime">
                        <div className="timezone">
                            {dateRangeTitle} <label>{timezone ? timezone : DEFAULT_TIMEZONE} Time</label>
                        </div>
                        <Button className="btnCancle" onClick={() => setOpen(false)}>
                            Cancel
                        </Button>
                        <Button className="btnSubmit" onClick={confirmDateRange}>
                            Confirm
                        </Button>
                    </div>
                </div>
            </div>
        );
    };

    const onDateConfirm = () => {
        setDateRangeListSelect({ ...dateRangeListSelect, dates: mobileDates.map(date => moment(date)) });
        // setDateRange(mobileDates.map(date => moment(date)));
        setShowDatePanel({ list: false, range: false });
    };

    const onCustomDateClick = () => {
        setDateRangeListSelect({ ...dateRangeListSelect, selected: "custom" })
        updateDatePanel({ list: false, range: true });
    }

    const onCustomDateConfirm = () => {
        updateDatePanel({ list: false, range: false });
        if (onSetDateRange) onSetDateRange({ selected: dateRangeListSelect.selected, dates: mobileDates.map((date) => moment(date)) });
    }

    return (
        isMobile ? (
            <div className="date-range-container">

                <button onClick={toggleFilterPanel} className="date-range-button">
                    {dateRangeTitle}
                    <span className="icon-container">
                        <DownOutlined className="carat" />
                    </span>
                </button>

                {showDatePanel?.list && (
                    <div className="calendar-panel">
                        <div className="filter-menubar datepicker-menubar">
                            <p>Preset Date Range</p>
                            <img src={close} alt="close" onClick={() => updateDatePanel({ list: false, range: false })} />
                        </div>
                        {dateRangeListView}
                    </div>
                )}

                {showDatePanel.range && (
                    <div className="calendar-panel mobile-date-range-picker">
                        <div className="filter-menubar datepicker-menubar">
                            <p>Custom Date Range</p>
                            <img src={close} alt="close" onClick={() => updateDatePanel({ list: false, range: false })} />
                        </div>
                        <div className="time-schedule">
                            <div>
                                <p>{dateRange?.[0]?.format('MMMM DD, YYYY')}</p>
                                <span>{dateRange?.[0]?.format('dddd')}</span>
                            </div >
                            <h6>{dateRange?.[1]?.diff?.(dateRange?.[0], 'days')} Days</h6>
                            <div className="right-time">
                                <p>{dateRange?.[1]?.format('MMMM DD, YYYY')}</p>
                                <span>{dateRange?.[1]?.format('dddd')}</span>
                            </div>
                        </div>
                        <ReactDatePicker inline selectsRange className="filter-option" startDate={mobileDates[0]} endDate={mobileDates[1]} onChange={setMobileDates} />
                        <div className="cancel-confirm-button">
                            <Button className="cancel-button" onClick={() => updateDatePanel({ list: true, range: false })}>Cancel</Button>
                            <Button className="confirm-button" type="primary" onClick={confirmDateRange}>Confirm</Button>
                        </div>
                    </div>
                )}

            </div>
        ) : (
            <div className="date-range-container">
                <RangePicker
                    value={dateRangeListSelect.dates}
                    open={open}
                    onChange={e => changeDateRangeFilter(e)}
                    onOpenChange={isOpen => isOpen && setOpen(isOpen)}
                    format={'LL'}
                    renderExtraFooter={DatePickerExtraFooter}
                    suffixIcon={<DownOutlined className={`date-range-picker`} />}
                />
            </div>
        )
    );
};